export default __webpack_public_path__ + "static/media/popup_production_graph.0d7df29b.jpg";